module.exports = __webpack_public_path__ + "img/bg.30fb3d25.png";